module.exports = __webpack_public_path__ + "img/SKMJ_mesh2.fdcf8d2a.jpg";